import jQuery from 'jquery';

var PLUGIN_NAME = 'InvestmentCalculator';
var ELEMENT_SELECTOR = '[data-investment-calculator]';
var FUND_LIST_ELEMENT_SELECTOR = '[data-investment-calculator-fund-list]';
var INVESTOR_CONTRIBUTION_ELEMENT_SELECTOR =
    '[data-investment-calculator-investor-contribution]';
var HORT_CONTRIBUTION_ELEMENT_SELECTOR =
    '[data-investment-calculator-hort-contribution]';
var BUDGET_ELEMENT_SELECTOR = '[data-investment-calculator-budget]';
var ERROR_ELEMENT_SELECTOR = '[data-investment-calculator-error]';

class InvestmentCalculator {
    constructor(element) {
        this.element = element;
        this.$element = jQuery(element);
        this.$fundListElement = this.$element.find(FUND_LIST_ELEMENT_SELECTOR);
        this.$hortElement = this.$element.find(
            HORT_CONTRIBUTION_ELEMENT_SELECTOR
        );
        this.$investorElement = this.$element.find(
            INVESTOR_CONTRIBUTION_ELEMENT_SELECTOR
        );
        this.$budgetElement = this.$element.find(BUDGET_ELEMENT_SELECTOR);
        this.$errorElement = this.$element.find(ERROR_ELEMENT_SELECTOR);

        this.watch();
    }

    watch() {
        var hortEl = this.$hortElement;
        var investEl = this.$investorElement;
        var calc = this;

        this.$fundListElement.change(function () {
            hortEl.val('');
            investEl.val('');
            calc.calculate();
        });

        this.$budgetElement.bind('keydown keyup', function (e) {
            calc.setBudget(e);
        });
    }

    setBudget(e) {
        if (e.shiftKey || e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (
                !(
                    key == 8 ||
                    key == 46 ||
                    (key >= 35 && key <= 40) ||
                    (key >= 48 && key <= 57) ||
                    (key >= 96 && key <= 105)
                )
            ) {
                e.preventDefault();
            }

            this.calculate();
        }
    }

    calculate() {
        var select = this.$fundListElement.val();
        if (select == 0) {
            this.$errorElement.text('Please select a Hort Frontiers fund');
        } else {
            this.$errorElement.text('');

            var price = this.$budgetElement.val();
            var str = price.replace(/[^\d.]/g, '');

            this.$budgetElement.val('' + this.formatNumber(str));

            if (str.length >= 1) {
                var investorContribution = this.getInvestorContribution(
                    str,
                    select
                );
                var hortContribution = this.getHortContribution(str, select);
                var res1 = parseFloat(investorContribution).toFixed(2);
                var res2 = parseFloat(hortContribution).toFixed(2);

                this.$investorElement.val('' + this.formatNumber(res1));
                this.$hortElement.val('' + this.formatNumber(res2));
            } else {
                this.$investorElement.val('');
                this.$hortElement.val('');
            }
        }
    }

    formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    getContributionAmount(price, percentage) {
        var total = parseFloat(price) * parseFloat(percentage);
        return total / 100;
    }

    getInvestorContribution(price, selectedFund) {
        var percentageStr = jQuery('[name="' + selectedFund + '"]').val();
        var percentage = percentageStr.replace(/[^\d.]/g, '');

        return this.getContributionAmount(price, percentage);
    }

    getHortContribution(price, selectedFund) {
        var percentageStr = jQuery('[name="' + selectedFund + '"]').val();
        var percentage = percentageStr.replace(/[^\d.]/g, '');

        var hortPercentage = 100 - percentage;

        return this.getContributionAmount(price, hortPercentage);
    }
}

jQuery(document).ready(function () {
    jQuery(ELEMENT_SELECTOR).each(function () {
        var calc = new InvestmentCalculator(this);
    });
});



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/investment-calculator/investment-calculator.js